import { z } from 'zod'

import { IntegrationType } from 'common/actions/integrations/common/constants/IntegrationType'
import { IntegrationSchema, IntegrationShortSchema } from 'shared/api/common/schemas/integration'

export const commonIntegrationSchemas = {
  disconnectIntegration: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ type: z.string() }),
    response: z.object({
      connected_integrations: IntegrationShortSchema.or(z.array(z.void()).length(0)),
    }),
  },
  getIntegration: {
    path: z.undefined(),
    query: z.object({ type: z.nativeEnum(IntegrationType) }),
    request: z.undefined(),
    response: z.object({ integration: IntegrationSchema }),
  },
  connectIntegrationByToken: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      type: z.nativeEnum(IntegrationType),
      token: z.string().optional(),
      additionalData: z.record(z.string(), z.string()).optional(),
    }),
    response: z.object({ integration: IntegrationSchema }),
  },
}
